module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "sockets-card",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Sockets")])]), _vm._v(" "), _vm._l((_vm.$store.state.boards), function(board, isb) {
    return _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('h4', {
      staticClass: "board-header"
    }, [_c('i', {
      staticClass: "el-icon-info",
      on: {
        "click": function($event) {
          _vm.showBoardResults(isb)
        }
      }
    }), _vm._v(" Board " + _vm._s(board.id)), (board.running) ? _c('span', {
      staticStyle: {
        "color": "#393"
      }
    }, [_vm._v(" (running test)")]) : _vm._e(), _vm._v(" has run\n      " + _vm._s(board.tests_done) + " tests "), (board.error) ? _c('span', {
      staticStyle: {
        "color": "#939"
      }
    }, [_vm._v(_vm._s(board.error))]) : _vm._e()]), _vm._v(" "), _c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.tableData(board),
        "header-cell-style": {
          color: '#000'
        },
        "cell-style": _vm.getCellStyle
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "socket",
        "label": "Socket"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n         " + _vm._s(scope.row.socket) + "\n          "), (_vm.hasSocketResults(isb, scope.row.socket)) ? _c('i', {
            staticClass: "el-icon-info",
            on: {
              "click": function($event) {
                _vm.showSocketResults(isb, scope.row.socket)
              }
            }
          }) : _vm._e()]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "80px",
        "prop": "state",
        "label": "State"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "current_retry",
        "label": "Retried"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "chip_id",
        "label": "Chip ID"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "result",
        "label": "Result"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "fail_tray",
        "label": "Fail tray"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "source_index",
        "label": "Source"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "v_tests",
        "label": "Tests"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "v_ok",
        "label": "Ok"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "v_fails",
        "label": "Fails"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "v_yield",
        "label": "Yield"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "retries",
        "label": "Retries"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Result breakdown for ' + _vm.dialog.what,
      "visible": _vm.dialog.visible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.$set(_vm.dialog, "visible", $event)
      }
    }
  }, [_c('results-plot', {
    attrs: {
      "data": _vm.dialog.data
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-412f799c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sockets-card.vue
// module id = 713
// module chunks = 1